<template>
  <div :class="['record-item', {'selected': selected, 'lmr-design': isLmrConsumer}]">
    <div class="record-header">
      <div class="record-tags">
        <m-l-tags :record="record" />
      </div>
      <div class="controls" >
        <div v-if="record.mldata.approved " v-for="proc of processStatusesSorted" :key="proc.process + proc.status">
          <span class="download-action glyphicon glyphicon-download-alt clickable"
              v-if="proc.process === 'intro' && ['done', 'error'].includes(proc.status)"
              :title="$t('records.download')"
              @click.stop.prevent="downloadRecord(record)"
              :class="{highlight: record.mldata.notes}"
          ></span>
          <span class="download-waiting-action glyphicon glyphicon-download-alt waving"
              v-if="proc.process === 'intro' && proc.status === 'waiting'"
              :title="$t('process_status.download_waiting')"
          ></span>
          <span class="download-waiting-action glyphicon glyphicon-download-alt waving"
              v-if="proc.process === 'intro' && proc.status === 'running'"
              :title="$t('process_status.download_waiting')"
          ></span>
        </div>
        <div v-if="record.mldata.approved && !getProcessList.includes('intro') && !getProcessList.includes('cut')">
          <span class="download-action glyphicon glyphicon-download-alt clickable"
              :title="$t('records.download')"
              @click.stop.prevent="downloadRecord(record)"
              :class="{highlight: record.mldata.notes}"
          ></span>
        </div>
        <div v-if="!record.mldata.approved" class="notes">
          <span class="glyphicon glyphicon-edit clickable"
            :title="$t('records.edit_comment')"
            @click.stop.prevent="editRecordNotes(record)"
            :class="{highlight: record.mldata.notes}"
          ></span>
        </div>
        <!-- <div v-if="!readOnly"  class="relevance">
          <span class="glyphicon glyphicon-thumbs-up clickable"
            :class="{highlight: record.mldata.marked_as_relevant}"
            @click.stop.prevent="markRecord(record, true)"></span>
          <span class="glyphicon glyphicon-thumbs-down clickable"
            :class="{highlight: record.mldata.marked_as_relevant === false}"
            @click.stop.prevent="markRecord(record, false)"></span>
        </div> -->
        <div class="download-action" v-if="!record.mldata.approved && !record.ghost">
          <span class="glyphicon glyphicon-download-alt clickable"
              :title="$t('records.download')"
              @click.stop.prevent="downloadRecord(record)"
              :class="{highlight: record.mldata.notes}"
          ></span>
        </div>
        <div class="download-waiting-action" v-if="record.ghost">
          <span class="glyphicon glyphicon-download-alt waving"
              :title="$t('process_status.download_waiting')"
              :class="{highlight: record.mldata.notes}"
          ></span>
        </div>
        <div v-if="!hideDeleteIcon" class="delete-record" title="">
          <span
            v-if="record.mldata.deleted_at"
            class="glyphicon clickable glyphicon-repeat"
            @click.stop.prevent="restoreRecord()"
            :title="$t('records.restore')"
          ></span>
          <span
            v-else-if="record.record_type=='VIDEO'"
            class="glyphicon clickable glyphicon-trash"
            @click.stop.prevent="deleteRecord()"
            :title="$t('records.delete')"
          ></span>
          <span
            v-else-if="record.record_type=='IMAGE'"
            class="glyphicon clickable glyphicon-trash"
            @click.stop.prevent="deleteRecord()"
            :title="$t('records.delete_image')"
          ></span>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="process-checkmarks" >

        <span
          v-for="proc of processStatusesSorted" :key="proc.process + proc.status"
          class="process-status"
          :title="$t(`process_status.${proc.process}_${proc.status}`)"
        >
          <img class="waving"
            v-if="proc.process === 'cut' && proc.status === 'running'"
            src="~@/assets/img/scissors-icon-black.svg" :alt="$t('records.alt_trimming')"
          >
          <img
            v-if="proc.process === 'cut' && proc.status === 'done'"
            src="~@/assets/img/scissors-icon-checked.svg" :alt="$t('records.alt_trimming_done')"
          >
          <v-icon
            color="red"
            v-if="proc.process === 'cut' && proc.status === 'error'"
          >error</v-icon>
          <template v-if="$route.path !== '/videos'">
            <img
              v-if="proc.process === 'intro' && proc.status === 'waiting'"
              src="~@/assets/img/gramophone-icon-gray.svg" :alt="$t('records.alt_process')"
            >
            <img class="waving"
              v-if="proc.process === 'intro' && proc.status === 'running'"
              src="~@/assets/img/gramophone-icon-black.svg" :alt="$t('records.alt_processing')"
            >
            <img
              v-if="proc.process === 'intro' && proc.status === 'done'"
              src="~@/assets/img/gramophone-icon-checked.svg" :alt="$t('records.alt_processed')"
            >
            <v-icon
              color="red"
              v-if="proc.process === 'intro' && proc.status === 'error'"
            >error</v-icon>
          </template>
          <!-- <img
            v-if="proc.process === 'ftpupload' && proc.status === 'waiting'"
            src="~@/assets/img/upload-icon-gray.svg" alt="Uploading queued"
          >
          <img class="waving"
            v-if="proc.process === 'ftpupload' && proc.status === 'running'"
            src="~@/assets/img/upload-icon-black.svg" alt="Uploading"
          > -->
          <v-icon
            class="waiting-link"
            v-if="proc.process === 'ftpupload' && proc.status === 'waiting'"
          >link</v-icon>
          <v-icon
            class="waving-45"
            v-if="proc.process === 'ftpupload' && (
              proc.status === 'running' || (proc.status === 'done' && !record.digiteka_id)
            )"
          >link</v-icon>
          <v-icon
            color="red"
            v-if="proc.process === 'ftpupload' && proc.status === 'error'"
          >error</v-icon>
        </span>
        <v-btn
          v-if="digitekaLink"
          fab small flat
          class="dg-link"
          :title="$t('digiteka_copy_link_title')"
          :href="digitekaLink"
          target="_blank"
        ><v-icon>link</v-icon></v-btn>
      </div>
    </div>
    <div
      :class="['inner-record', 'center-block', {'clickable': isChoosingMode}]"
      @click="clickedRecordCardHandler(record)"
      :style="[record.consumer=='lng_sdk' ? {'background-color': '#eef5f9'} : {}]"
    >
      <thumbnail
        v-if="!record.ghost"
        @click.native.stop.prevent="clickedRecordHandler(record)"
        class="thumbnail clickable center-block"
        :media="record.media"
        :default="record.thumbnail_link"
      ></thumbnail>
      <div v-else class="thumbnail ghost center-block">
        <div class="loading-indicator"></div>
        <p>{{ $t('records.processing') }}</p>
      </div>
      <div v-if="isLmrConsumer">
        <div class="lmr-user-cat">
          <div class="category">{{ record.lmr_category }}</div>
          <v-select v-if="!record.mldata.approved && !record.mldata.deleted_at"
            :disabled="isChoosingMode"
            class="record_group"
            :items='record.available_groups.map(data => ({value: data.id, text: data.localized_name[0].translation}))'
            :label="$t('records.edition')"
            :value=record.groups[0].id
            dense
            outlined
            solo
            flat
            hide-details
            color="red"
            background-color="#dcdbdb"
            v-model="selected_group"
            v-on:input="changeEdition(record.id, selected_group)"
          ></v-select>
          <div class="edition" v-else-if="record.groups.length > 0 && record.mldata.approved && !record.mldata.deleted_at">{{ record.groups[0].group_name }}</div>
          <div class="edition" v-else-if="record.groups.length > 0 && !record.mldata.approved && record.mldata.deleted_at">{{ record.groups[0].group_name }}</div>
          <div v-else></div>
        </div>
        <p class="comment" v-if="!record.title && record.comment && record.consumer != 'lavoix'">
          {{ record.comment }}
        </p>
        <p class="comment" v-else>
          {{ record.title }}
        </p>
        <p>
          <small>{{ $t('records.recorded') }}
            <time-ago :value="record.shooting_date"></time-ago>
            <span v-html="$t('records.ago')"></span>
            <span v-html="$t('records.by')"></span><br />
            <span class="highlight">{{ record.user_full_name }}</span>
            <a :href="'tel:'+record.contact_phone"><br>{{record.contact_phone}}</a>
          </small>
        </p>
      </div>
      <p v-else>
        <small>{{ $t('records.recorded') }}
          <time-ago class="highlight" :value="record.shooting_date"></time-ago>
          <span v-html="$t('records.ago')"></span>
          <span v-html="$t('records.by')"></span><br />
          <span class="highlight">{{ record.user }}</span>
        </small>
      </p>
      <p class="highlight">
        <span v-if='record.mldata.relevance'> {{ $t('ml.relevance') }}: {{record.mldata.relevance}}</span>
        <span v-if='record.mldata.consistency'> {{ $t('ml.consistency') }}: {{record.mldata.consistency}}</span>
        <span v-if='record.mldata.diversity'> {{ $t('ml.diversity') }}: {{record.mldata.diversity}}</span>
      </p>
<!--      <template>-->
<!--        <p><span>{{record.vod_address}}</span></p>-->
<!--        <p class="actions">-->
<!--          <a class="faint" @click.stop.prevent="downloadRecord(record)" href='#' download>-->
<!--            {{ $t('records.download') }}-->
<!--          </a>-->
<!--        </p>-->
<!--      </template>-->
      <template v-if="selected">
        <div v-if="showSelectIndex" class="record-selected-marker" color="blue">
          {{selectIndex}}
        </div>
        <v-icon v-else class="record-selected-marker" color="blue">
          check_circle
        </v-icon>
      </template>
      <div
        v-if="record.merged" class="merged-icon"
        :title="$t('records.merged_title')"
      >
        <img src="~@/assets/img/animation-play.svg" alt="merged">
      </div>
    </div>
    <input type="text" class="copy-text" ref="copyText">
  </div>
</template>


<script>
// Records list component
// Load and render a list of vods for a marker
import Thumbnail from './Thumbnail.vue'
import MLTags from './MLTags.vue'
import TimeAgo from '../../generic/DatetimeAgo.vue'
import { mapGetters, mapActions } from 'vuex'
import RecordRepository from '../../../repositories/RecordRepository'
const FileSaver = require('file-saver')

export default {
  components: {
    Thumbnail,
    TimeAgo,
    MLTags
  },
  data () {
    return {
      tooltip: '',
      digitekaLink: '',
      digitekaDirectLink: '',
      selected_group: 0
    }
  },
  props: ['record', 'readOnly', 'selectedRecords', 'showSelectIndex', 'isChoosingMode'],
  mounted () {
    this.record.selected = false
    if (this.record.mldata.approved) {
      this.getDigitekaLink(this.record).then(link => this.setDigitekaLinks(link))
    }
    this.selected_group = this.record.groups[0].id
  },
  methods: {
    ...mapActions(['getDigitekaLink', 'buildDigitekaDirectLink']),
    clickedRecordHandler (record) {
      this.$emit('clicked-record-item', record)
    },
    clickedRecordCardHandler (record) {
      if (this.isChoosingMode === true) {
        this.$emit('clicked-record-item', record)
      }
    },
    // propagate the thumbs up/down event upwards for the parent component to catch
    markRecord (record, relevance) {
      this.$emit('mark-record-relevance-item', record, relevance)
    },
    deleteRecord () {
      this.$emit('delete-record-item', this.record)
      // this.recordPendingDeletion = record
    },
    restoreRecord () {
      this.$emit('restore-record-item', this.record)
    },
    editRecordNotes (record) {
      this.$emit('edit-record-notes', record)
      // this.recordNotesBeingEdited = record
    },
    setRecoverTooltip () {
      if (this.record.mldata.deleted_at) this.tooltip = 'click here to recover'
    },
    async downloadRecord (record) {
      const res = await fetch(record.play_link)
      const blob = await res.blob()
      FileSaver.saveAs(blob, record.verbose_filename)
      RecordRepository.setDownloaded(record.name)
    },
    setDigitekaLinks (link) {
      this.digitekaLink = link
      this.buildDigitekaDirectLink(this.record).then(dlink => {
        this.digitekaDirectLink = dlink
      })
    },
    copyDigitekaLink () {
      this.$refs.copyText.value = this.digitekaLink
      this.$refs.copyText.select()
      console.log('link', this.digitekaLink)
      document.execCommand('copy')
      this.$store.commit('snackbar/show', {
        message: this.$t('records.link_copied'),
        timeout: 2000,
        color: 'green'
      })
    },
    changeEdition (recordId, groupId) {
      RecordRepository.patchRecordEdition(recordId, {usergroup: groupId})
    }
  }, // methods
  computed: {
    ...mapGetters(['isLmrConsumer']),
    selected () {
      if (Array.isArray(this.selectedRecords)) {
        return this.selectedRecords.some(rec => rec.id === this.record.id)
      }
      return false
    },
    selectIndex () {
      if (this.selected) {
        return this.selectedRecords.findIndex(record => record.id === this.record.id) + 1
      }
    },
    hideDeleteIcon () {
      return this.readOnly || this.record.mldata.approved
    },
    processStatusesSorted () {
      // guard: optimistic/ghost records may not carry process_statuses yet —
      // a missing field would otherwise crash the whole card on render
      if (!this.record.process_statuses || this.record.process_statuses.length === 0) return []
      const processOrdering = ['cut', 'intro', 'ftpupload']
      // sort a copy: process_statuses is a prop shared by reference with the
      // parent's records list, so sorting in place would mutate parent state
      return this.record.process_statuses.slice().sort((a, b) => {
        const aIndex = processOrdering.indexOf(a.process)
        const bIndex = processOrdering.indexOf(b.process)
        if (aIndex < bIndex) return -1
        else if (aIndex > bIndex) return 1
        else return 0
      })
    },
    getProcessList () {
      let processList = (this.record.process_statuses || []).map((a) => {
        return a.process
      })
      return processList
    }
  },
  watch: {
    'record.digiteka_id': function (newVal, oldVal) {
      if (newVal) {
        this.getDigitekaLink(this.record).then(link => this.setDigitekaLinks(link))
      }
    }
  }
}
</script>

<style lang="sass">
.lmr-design
  .dg-link,
  .dg-direct-link
    cursor: pointer
    text-decoration: none
    .v-icon
      color: #41af41
  .dg-link
    background-color: #04a904
    border-radius: 50%
    margin: -6px -10px 0 5px
    border: 2px solid green
    .v-icon.material-icons
      transform: rotate(-45deg)
      color: white
  .dg-direct-link
    top: 50px
  .thumbnail
    margin-bottom: 5px
  .v-icon
    color: #a8a8a8
  .v-btn__content .v-icon.material-icons
    width: 30px
  .v-btn--floating.v-btn--small
    width: 30px
    height: 30px
    .v-icon
      font-size: 26px
  a.dg-link .v-icon
    line-height: 26px
    text-align: center
  .comment
    height: 60px
    overflow-y: hidden
    font-size: 14px
    max-width: 240px
    margin: 5px auto 0
.inner-record
  .dg-link
    position: absolute
    right: 6px
    top: 3px
    background-color: #dcdbdb
  .merged-icon
    position: absolute
    left: 14px
    top: 125px
    background: rgba(255, 255, 255, 0.7)
    border-radius: 3px


.lmr-user-cat
  display: flex
  justify-content: space-between
  max-width: 210px
  margin: auto
  .category
    background: #dcdbdb
    border-radius: 4px
    padding: 1px 2px
    width: 49%
    font-size: 10px
    text-align: center
    text-transform: uppercase
    font-weight: bold
    display: grid
    align-items: center
.process-checkmarks
  display: flex
  & > span ~ span
    margin-left: 2px
  .waiting-link
    transform: rotate(-45deg)
.copy-text
  height: 0
  width: 1px
  position: absolute
  z-index: -1
.thumbnail.ghost
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column
  .loading-indicator
    width: 40px
    height: 40px
    border-radius: 50%
.record_group
  color: red
.record_group.v-text-field input
  display: none
//v-text-field.v-text-field--solo .v-input__control
//  min-height: 48px
//  padding: 0
.lmr-user-cat .v-input
  font-size: 10px
  font-weight: bold
  text-transform: uppercase
.lmr-user-cat
  .category
    margin-left: 5px
    width: auto
    min-width: 30%
    padding: 0 5px
    box-sizing: border-box
    min-height: 30px
  .edition
    background: #dcdbdb
    border-radius: 4px
    font-size: 10px
    text-align: center
    text-transform: uppercase
    font-weight: bold
    display: grid
    align-items: center
    margin-right: 4px
    margin-left: 4px
    width: 100%
    min-width: 50%
    padding: 0 5px
    box-sizing: border-box
    min-height: 30px
  .v-select__selections
    align-items: center
    text-align: center
    display: flex
    flex: 1 1 auto
    flex-wrap: wrap
    line-height: 14px
  .v-text-field .v-input__append-inner
    padding-left: 0
  .theme--light.v-text-field--solo>.v-input__control>.v-input__slot
    border-radius: 4px
    box-sizing: border-box
  .v-text-field.v-text-field--solo .v-input__control
    min-height: 30px
    padding: 0
    margin-right: 8px
  .v-select__selection--comma
    text-align: center
    align-items: center
    display: inline-flex
    margin: 0 auto
    padding: 7px 4px
  .v-text-field.v-text-field--enclosed .v-text-field__details, .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot
    padding: 0
    margin: 0 0 0 4px

</style>
